import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BarChartData } from 'Molecules/InsightsChart/chartBuilder';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseCapacityManagementEstimatedVsActualHoursTeamsPayload } from '../payloads/capacityManagementEstimatedVsActualHoursTeamsPayload';
import { InsightChartFactory } from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';
import intl from 'react-intl-universal';

export const buildCapacityManagementEstimatedVsActualHoursTeamsInsightFactory =
  (payload: BaseInsightPayload): InsightChartFactory => {
    const parsedPayload =
      parseCapacityManagementEstimatedVsActualHoursTeamsPayload(payload);
    const { data } = parsedPayload.data.attributes;

    return (props) => {
      const chart = new ChartBuilder()
        .setChartType(ChartType.V_BAR)
        .setProps({
          chartData: data as BarChartData,
          onDrillDown: props.onDrillDown,
          xAxisFieldName: 'team_name',
          yAxisFieldNames: [
            'allocated_hours_in_range',
            'actual_hours_in_range',
          ],
          legendNames: [
            intl.get('INSIGHT.LEGEND.ALLOCATED_HOURS'),
            intl.get('INSIGHT.LEGEND.ACTUAL_HOURS'),
          ],
        })
        .build();

      return DefaultChartWithTrendSupport({
        chartComponent: chart,
      });
    };
  };
